<!-- Button -->
  <!-- <img
            class="w-7 h-7 rounded-full"
            *ngIf="!showAvatar && !user.avatar"
            [src]="user.avatar"> -->
            <!-- *ngIf="showAvatar || user.avatar" -->

<button
    mat-button
    [matMenuTriggerFor]="userActions" id="userActionsBtn" class="flex items-center pl-0 mr-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"> 
    <span class="relative flex items-center">
        <mat-icon class="text-2xl h-[30px] w-[30px]"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user?.avatar,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"
        ></span>

        <span class="ml-1">{{userName}}</span>
        <mat-icon>expand_more</mat-icon>


    </span>
</button>
<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <!-- <button mat-menu-item id="userCmp_userNameBtn">
        <span class="flex flex-col leading-none">
            <span>{{"settings.label" | translate}}</span>
            <span class="mt-1.5 text-md font-medium">{{userName}}</span>
        </span>
    </button> -->
    <!-- <mat-divider class="my-2"></mat-divider> -->
    <button class="hidden" id="userCmp_profileBtn" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item (click)="navigateToUserSettings()" id="userCmp_navToUserSettingsBtn">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>{{"settings.settingsLabel" | translate}}</span>
    </button>
    <!-- <button
        mat-menu-item id="userCmp_userStatusBtn"
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>{{"statusLabel" | translate}}</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item id="userCmp_signOutBtn"
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{"settings.signOutNewLabel" | translate}}</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item id="userCmp_onlineStatusBtn"
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item id="userCmp_awayStatusBtn"
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item id="userCmp_busyStatusBtn"
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item id="userCmp_notVisibleStatusBtn"
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
